module.exports = __webpack_public_path__ + "static/future-work-home-1-6f5a78f7e472abc183748ce37a225d37.jpg";